/**
 * Phase Selector Component - Select active phase for simulation
 */

import React from 'react';
import { useSimulatorStore } from '../../stores/simulatorStore';

export const PhaseSelector: React.FC = () => {
  const { currentCriterion, currentPhase, selectPhase, selectedClip } = useSimulatorStore();

  if (!currentCriterion || !currentCriterion.content?.phases) {
    return null;
  }

  const phases = currentCriterion.content.phases;

  // Only show selector if there are multiple phases
  if (phases.length <= 1) {
    return null;
  }

  const handlePhaseChange = (phaseId: string) => {
    selectPhase(Number(phaseId), selectedClip?.diaperModelCode || null);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-4 mb-4">
      <label className="block text-sm font-semibold mb-2">
        🕐 Active Phase
        <span className="ml-2 text-xs font-normal text-gray-500">
          (affects Change Needed thresholds)
        </span>
      </label>
      <select
        value={currentPhase?.id || ''}
        onChange={(e) => handlePhaseChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-white"
      >
        {phases.map((phase) => (
          <option key={phase.id} value={phase.id}>
            {phase.name}
            {phase.thresholds && phase.thresholds.length > 0 && (
              ` (${phase.thresholds.length} threshold${phase.thresholds.length !== 1 ? 's' : ''})`
            )}
          </option>
        ))}
      </select>
      
      {currentPhase && (
        <div className="mt-2 text-xs text-gray-600">
          <span className="font-medium">Selected Phase:</span> {currentPhase.name}
          {currentPhase.thresholds && currentPhase.thresholds.length > 0 && (
            <span className="ml-2">
              • {currentPhase.thresholds.length} diaper model threshold{currentPhase.thresholds.length !== 1 ? 's' : ''}
            </span>
          )}
        </div>
      )}
    </div>
  );
};







